// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"839f23a5","455":"7a866f1c","488":"3a58540e","977":"1634a532"}[chunkId] + ".chunk.js";
};